import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"



class CategoriaAdmin extends Component {
state = {
  nome:null,
  email:null,
  password:null,
  admunidades:[],
  error:null,
  success:null,
  unidades:[],
  idunidade:"",
  btn:"Cadastrar",
  btndisabled:false,
  idtodel:"",
  idtoedit:"",
  idaction:"1",
}

async loadadms () {
  const response = await api.post("/admin/admunidades");
  this.setState({ admunidades: response.data });
}

  async componentDidMount(){
    this.loadadms();
    this.loadunidades();
  }

  async loadunidades () {
    const response = await api.post("/unidades");
    this.setState({ unidades: response.data });
  }



  async loadfilladm (id) {
    const response = await api.post("/admin/admunidade/show", {id:id});
    this.setState({ nome:response.data.name,
      email:response.data.email,
      password:response.data.password,
      idunidade:response.data.admunidade
  });

    console.log(this.state);
  }


  admunidadeaction = async e => {
    e.preventDefault();
    
    if(this.state.idaction=="2"){
      this.editadmunidade();
    }else if(this.state.idaction=="3"){
      this.deladmunidade();
    }else{
      this.addadmunidade();
    }
      
    
  }


  deladmunidade = async e => {
    this.setState({ btndisable: true });
    const { idtodel } = this.state;
      if (!idtodel) {
          this.setState({ error: "Erro !",
        success:null });
        this.setState({ btndisable: false });
        
      } else {
      const { nome } = this.state;
      const response = await api.post("/admin/admunidade/del", { id:idtodel });

        if(response.data.id){
          this.setState({ success: "Unidade Deletada!" , error:null , nome:"", idunidade:""
        , email:"", password:"", idtodel:"", idaction:"1"  });
          this.loadadms();
        }

        this.setState({ btndisable: false });

      }
  }


  addadmunidade = async e => {
    this.setState({ btndisable: true });
    const { nome, email, password,idunidade } = this.state;
      if (!nome || !email || !idunidade || !password) {
          this.setState({ error: "Preencha o nome antes de adicionar um novo!",
        success:null });
        this.setState({ btndisable: false });
          
      }
      else {
      const { nome } = this.state;
      const response = await api.post("/admin/admunidade/add", { nome, email,idunidade,password  });

        if(response.data.id){
          this.setState({ success: "Unidade Adicionada!" , error:null
        , idunidade:"", email:"", nome:"", password:""  });
          this.loadadms();

        }

        this.setState({ btndisable: false });

      }
  }


  editadmunidade = async e => {
    this.setState({ btndisable: true });

    const { idtoedit,nome, email,password, idunidade } = this.state;
    console.log(this.state)
      if ( !idtoedit || !nome || !email || !password || !idunidade ) {
          this.setState({ error: "Preencha o nome antes de editar!",
        success:null });
        this.setState({ btndisable: false });
          
      }
      else {
      const { nome } = this.state;
      const response = await api.post("/admin/admunidade/update", {id:idtoedit, nome, email,password, idunidade  });

        if(response.data.id){
          this.setState({ success: "Unidade atualizada!" , error:null
      , idunidade:"", email:"", nome:"", password:"", idtoedit:"",idaction:"1"  });
       this.loadadms();

        }else{
          this.setState({ error: response.data.error,
          success:null });
          this.setState({ btndisable: false });
        }
        
        this.setState({ btndisable: false });

      }
  }


  shouldComponentUpdate(nextProps, nextState)
  {
 


    if(nextState.idtoedit!==this.state.idtoedit){
      this.loadfilladm(nextState.idtoedit);
      
    

    }
    if(nextState.idtodel!==this.state.idtodel){
      this.loadfilladm(nextState.idtodel);

    

    }

    return true;
  }

  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-6 p-4">     

{this.state.idaction=="1" && <h4>Adicionar Novo Administrador</h4> }
{this.state.idaction=="2" && <h4>Atualizar Administrador # {this.state.idtoedit}</h4> }
{this.state.idaction=="3" && <h4>Deletar Administrador # {this.state.idtodel}</h4> }

        <form action="#" onSubmit={this.admunidadeaction}>

        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
          {this.state.idtoedit!=="" && 
        
        <div class="form-group">
        <label for="exampleFormControlInput1">ID Administrador</label>
        <input type="text" class="form-control" disabled defaultValue={this.state.idtoedit} placeholder="Digite o nome da nova Unidade" />
        </div>
        
        
        }
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" value={this.state.nome} required onChange={e => this.setState({ nome: e.target.value })} placeholder="Digite o nome da nova Categoria" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail</label>
                    <input type="email" class="form-control" value={this.state.email} required onChange={e => this.setState({ email: e.target.value })} placeholder="Digite o nome da nova Categoria" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Senha</label>
                    <input type="password" class="form-control" value={this.state.password} required onChange={e => this.setState({ password: e.target.value })} placeholder="Digite o nome da nova Categoria" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Unidade</label>
                    <select class="browser-default custom-select" value={this.state.idunidade} required onChange={e => this.setState({ idunidade: e.target.value })} >
                    <option value="0" >Selecione um valor</option>

                    {this.state.unidades.map(el => (
                      <option value={el.id} selected={this.state.idunidade==true}>{el.nome}</option>
                    ))}
                    </select>
                </div>
                <div class="form-group">
                  {this.state.idaction=="1" && <button class="btn btn-primary mb-2" disabled={this.state.btndisable==true}>Adicionar</button>}
                  {this.state.idaction=="2" && <button class="btn btn-primary mb-2" disabled={this.state.btndisable==true}>Atualizar</button>}
                  {this.state.idaction=="3" && <button class="btn btn-danger mb-2" disabled={this.state.btndisable==true}>Voce deseja deletar?</button>}

                </div>
        </form>














    {/* Tables */}

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
  <tr>
    <th class="th-sm">ID

    </th>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">E-mail

      </th>
      <th class="th-sm">Unidade

      </th>
      <th class="th-sm">Ação

      </th>
    </tr>
  </thead>
   <tbody>
  {this.state.admunidades.map(el => (
    <tr>
    <td>{el.id}</td>
    <td>{el.name}</td>
    <td>{el.email}</td>
    <td>{el.unidade.nome}</td>
    <td>
    <a class="btn btn-primary btn-sm" href="#" onClick={e => this.setState({ idtoedit: el.id, idaction:"2" })}>Editar</a>
      <a class="btn btn-danger btn-sm" href="#" onClick={e =>  this.setState({ idtodel: el.id, idaction:"3" })}>Excluir</a>
    </td>
  </tr>
  ))}
    

   
  </tbody>

</table>

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(CategoriaAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/admunidades.js